import React, { useRef, useEffect, useState } from "react";

const Stories = () => {
   useEffect(() => {
      document.title = "Stories - MedEngage";
    }, []);
     useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
        const [loading, setLoading] = useState(true);

        // ✅ useEffect instead of React.useEffect
        useEffect(() => {
          const timer = setTimeout(() => {
            setLoading(false);
          }, 300); // loader disappears after 2s

          return () => clearTimeout(timer);
        }, []);
  
    const [loadingFirst, setLoadingFirst] = useState(true);
    const [loadingSecond, setLoadingSecond] = useState(true);
  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}

      <section className="ul-section-spacing">
        <div className="container">
          <h2 className="ul-section-title text-center mb-5">
            <span className="green">MedEngage</span> Stories
          </h2>

          <div className="row g-4 justify-content-center">
            {/* First Video Card */}
            <div className="col-lg-6 col-md-8">
              <div className="card shadow-sm h-100 border-0 rounded-3 overflow-hidden position-relative">
                {loadingFirst && (
                  <div className="video-loader-overlay d-flex justify-content-center align-items-center">
                    <div className="spinner-border text-success" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/xzvmClF_3WQ?autoplay=0&mute=0&color=red&controls=1&loop=0&rel=0&start=0&cc_load_policy=0&iv_load_policy=3&enablejsapi=1"
                    title="YouTube video 1"
                    allowFullScreen
                    style={{ border: 0 }}
                    onLoad={() => setLoadingFirst(false)}
                  ></iframe>
                </div>
                <div className="card-body text-center">
                  <h4 className="card-title fw-bold">
                    MedEngage Event Highlights
                  </h4>
                  <p className="card-text text-muted">
                    Watch how our programs engage and empower the medical
                    community.
                  </p>
                </div>
              </div>
            </div>

            {/* Second Video Card */}
            <div className="col-lg-6 col-md-8">
              <div className="card shadow-sm h-100 border-0 rounded-3 overflow-hidden position-relative">
                {loadingSecond && (
                  <div className="video-loader-overlay d-flex justify-content-center align-items-center">
                    <div className="spinner-border text-success" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/0HqBY5-BpKo?autoplay=0&mute=0&color=red&controls=1&loop=0&rel=0&start=0&cc_load_policy=0&iv_load_policy=3&enablejsapi=1"
                    title="YouTube video 2"
                    allowFullScreen
                    style={{ border: 0 }}
                    onLoad={() => setLoadingSecond(false)}
                  ></iframe>
                </div>
                <div className="card-body text-center">
                  <h4 className="card-title fw-bold">
                    MedEngage Community Impact
                  </h4>
                  <p className="card-text text-muted">
                    Learn about stories of impact from our initiatives across
                    the country.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Stories;
